import React, {Component, createRef} from 'react';
import FJControllerPlayIcon from '../../../../icon/previewPlay.svg';
import FJControllerStopIcon from '../../../../icon/previewStop.svg';
import FJUtil from '../../../../util/FJUtil';
import FJPreviewVolumeContainer from './FJPreviewVolumeContainer';
import FJSlider from '../../../../common/component/slider/FJSlider';
import InlineSVG from "react-inlinesvg"
import key from 'keymaster'

import "./FJPreviewProjectController.less";

class FJPreviewProjectController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      progress: 0,
    };
    this.volume = createRef();
    this._isPlayingStateBeforeSeek = false;
  }

  componentDidMount() {
    key('space', 'record', () => {
      this.triggerController();
    });
  }

  componentWillUnmount() {
    key.unbind('space', 'record');
  }

  getVolume = () => {
    return this.volume.current.getVolume();
  };
  isPlaying = () => {
    return this.state.isPlaying;
  };
  updateProgress = (progress) => {
    this.setState({isPlaying: true, progress: progress});
  };
  getProgress = () => {
    return this.state.progress;
  };
  reset = () => {
    this.setState({isPlaying: false, progress: 0});
  };
  resetVolume = () => {
    this.volume.current.resetVolume();
  };

  triggerController = (e, toggle) => {
    if (e) {
      e.stopPropagation();
    }
    this.volume.current.hideVolume();
    if (typeof toggle === 'undefined') {
      if (this.state.isPlaying) {
        this._pause();
      } else {
        this._play();
      }
    } else {
      if (toggle) {
        this._play();
      } else {
        this._pause();
      }
    }
  };
  changePlayState = (play) => {
    this.setState({isPlaying: play});
  };
  _play = () => {
    let result = this.props.play();
    if (false !== result) {
      this.setState({isPlaying: true});
    }
  };
  _pause = () => {
    this.setState({isPlaying: false});
    this.props.pause();
  };
  _onBeforeChange = (value, progress) => {
    this._isPlayingStateBeforeSeek = this.state.isPlaying;
    if (this.state.isPlaying) {
      this._pause();
    }
    this.props.dataChange({type: 'start', progress: progress});
    this.setState({progress: progress});
  };
  _onChange = (value, progress) => {
    this.props.dataChange({type: 'dataChange', progress: progress});
    this.setState({progress: progress});
  };
  _onAfterChange = (value, progress) => {
    this.props.dataChange({type: 'end', progress: progress});
    if (this._isPlayingStateBeforeSeek) {
      this._play();
    }
  };

  render() {
    let progress = this.state.progress;
    let curTime = progress * this.props.duration;
    let currentTime = FJUtil.formatTime(curTime);
    let totalTime = FJUtil.formatTime(this.props.duration);
    return (
      <div className='c-modal-preview-controller'>
        <div className='c-modal-preview-progress'>
          <FJSlider progress={progress}
                    onBeforeChange={this._onBeforeChange}
                    onChange={this._onChange}
                    onAfterChange={this._onAfterChange}
          />
        </div>
        <div className='c-modal-preview-ctr__operate'>
          <div onClick={(e) => this.triggerController(e)} className='u-button-cursor c-preview-play'>
            {this.state.isPlaying ? <InlineSVG src={FJControllerStopIcon} element='div'/> :
              <InlineSVG src={FJControllerPlayIcon} element='div'/>}
          </div>
          <FJPreviewVolumeContainer ref={this.volume}
                                    previewVolumeChang={this.props.previewVolumeChange}/>
          <span className='c-modal-preview-ctr__time'>{currentTime + " / " + totalTime}</span>
        </div>
      </div>
    );
  }
}

export default FJPreviewProjectController;
